import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface RequireAdminProps {
  children: React.ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        console.log("Checking admin status...");
        
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          console.log("No user found, redirecting to login");
          toast.error("Vous devez être connecté pour accéder à cette page");
          navigate("/login");
          return;
        }

        console.log("User found, checking admin role...");
        
        const { data, error } = await supabase
          .rpc('has_role', {
            user_id: user.id,
            role: 'admin'
          });

        if (error) {
          console.error("Error checking admin role:", error);
          throw error;
        }

        console.log("Admin check result:", data);
        
        if (!data) {
          console.log("User is not admin, redirecting to home");
          toast.error("Vous n'avez pas les droits pour accéder à cette page");
          navigate("/");
          return;
        }

        setIsAdmin(true);
      } catch (error) {
        console.error("Error in admin check:", error);
        toast.error("Une erreur est survenue");
        navigate("/");
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00ADB5]"></div>
      </div>
    );
  }

  return isAdmin ? children : null;
}